import { Directive, Input, ElementRef, Renderer2, OnInit, SimpleChanges } from '@angular/core';
import { StaticPathPipe } from '../pipes/static-path.pipe';
import {OnChanges} from '@angular/core';

@Directive({
  selector: '[appImgIxImage]'
})

export class ImageIxImageDirective implements OnInit, OnChanges {
  @Input() url: string;
  @Input() fallbackImageUrl: string = '/assets/no_image_placeholder.jpg'; // The fallback URL to use

  // Use this to set the quality of the images, lower for lower sized pictures
  @Input() imageQualityPercentage: number = 0;
  @Input() showHighDprImages: boolean = false;

  constructor(public renderer: Renderer2, private el: ElementRef, private staticPathPipe: StaticPathPipe) {
  }

  ngOnInit() {
    this.refreshImageData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.url) {
      this.renderer.removeAttribute(this.el.nativeElement, 'data-src');
      this.renderer.removeAttribute(this.el.nativeElement, 'data-srcset');
      this.renderer.removeAttribute(this.el.nativeElement, 'srcset');
      this.renderer.removeAttribute(this.el.nativeElement, 'src');
    }
    this.refreshImageData();
  }

  private refreshImageData() {
    // We have lots of different sized images, and many are dynamic based on the width of the page.
    // Tried to take a reasonable sample of breakpoints to allow for dynamic sizing so we don't load images
    // that are larger than we need, while still having general enough sizes that we make use of imgix
    // caching at each breakpoint.
    const breakpoints = [
      '140', // Desktop LLDP thumbnails
//      '235', // Desktop Saved Listings 1200px width window
//      '270', // Desktop gallery carousel, Desktop Saved Listings 1366px width window
//      '285', // Desktop Saved Listings 1440px and 1920px width window
//      '300', // Mobile carousel
//      '315', // Desktop Saved Listings 1600px width window
      '320', // Desktop LDP Suggested Listings carousel
//      '385', // Desktop Saved Listings 2560px width window
//      '525', // Desktop LDP 1200px width window
//      '600', // Desktop LDP 1366px width window
//      '630', // Desktop LDP 1440px and LLDP 1200px width window
      '640', // Desktop LDP 1920px width window
//      '700', // Desktop LDP 1600px width window
//      '715', // Desktop LLDP 1366px width window
//      '755', // Desktop LLDP 1440px width window
//      '760', // Desktop LLDP 1920px width window
//      '830', // Desktop LDP Gallery 1200px width window
//      '840', // Desktop LLDP 1600px width window
      '850', // Desktop LDP 2560px width window
//      '945', // Desktop LDP Gallery 1366px and 1920px width window
//      '995', // Desktop LDP Gallery 1440px width window
//      '1020', // Desktop LLDP 2560px width window
//      '1105', // Desktop LDP Gallery 1600px width window
      '1255', // Desktop LDP Gallery and LLDP Gallery 2560px width window
    ];

    // Mobile and tablet users are shown 2x larger images to match their higher pixel density vs desktop monitors.
    const dpr = this.showHighDprImages ? '&dpr=2' : '';

    if (!this.url) {
      this.url = this.staticPathPipe.transform(this.fallbackImageUrl);
      this.renderer.setAttribute(this.el.nativeElement, 'data-src', this.url);
      this.renderer.setAttribute(this.el.nativeElement, 'data-srcset', this.url);
    } else {
      const srcSet = breakpoints.map((value) => this.url + '?w=' + value + '&fit=max&auto=format,compress' + '&cs=srgb' + dpr + ' ' + value + 'w').join(', ');
      this.renderer.setAttribute(this.el.nativeElement, 'data-srcset', srcSet);
      this.renderer.setAttribute(this.el.nativeElement, 'srcset', srcSet);

      // This will allow lazysizes to calculate the size of the container the image is being loaded in, and then select the correct
      // sized image from the srcset that is equal to or larger than the container so it will fill it, but load small images
      // if the container is small.
      this.renderer.setAttribute(this.el.nativeElement, 'data-sizes', 'auto');
    }
  }
}
